// Utilities
import { createSimpleFunctional } from "../../util/index.js";
export const VCardTitle = createSimpleFunctional('v-card-title');
//# sourceMappingURL=VCardTitle.js.map